<mat-progress-bar mode="indeterminate" *ngIf="analyze"></mat-progress-bar>
<mat-card
  appearance="outlined"
  fxLayout="row"
  fxLayout.xs="column"
  fxLayoutGap="16px"
  *ngIf="!claimService.hash && !error"
>
  <ngx-file-drop
    fxFlex
    (onFileDrop)="dropped($event)"
    dropZoneClassName="file-drop-zone"
    [multiple]="false"
    class="dropper"
  >
    <ng-template
      ngx-file-drop-content-tmp
      let-openFileSelector="openFileSelector"
    >
      <div
        fxLayout="column"
        fxLayoutAlign="center center"
        class="file-selector"
        (click)="openFileSelector()"
      >
        <mat-icon id="add-icon">add_circle_outline</mat-icon>
        <br />
        <p i18n>Place file here</p>
        <u i18n>Select file</u>
      </div>
    </ng-template></ngx-file-drop
  >
  <div fxFlex fxLayout="column" fxLayoutAlign="space-between stretch">
    <div>
      <h1 i18n>Verify documents quickly</h1>
      <p i18n>
        With TrustVerifier, they can quickly verify the authenticity of
        documents.
      </p>
    </div>
    <div fxLayout="row" fxLayoutAlign="end center">
      <img [src]="getLogo()" id="logo" />
    </div>
    <!-- <button mat-raised-button color="accent" routerLink="qr">
        Scan <mat-icon>qr_code_2</mat-icon>
      </button> -->
  </div>
</mat-card>
<div fxLayout="column" fxLayoutGap="16px">
  <trustsuite-verification-success
    *ngIf="claimService.hash"
    [isDialog]="false"
  ></trustsuite-verification-success>
  <trustsuite-verification-failed
    *ngIf="error"
  ></trustsuite-verification-failed>
  <button
    mat-raised-button
    color="accent"
    (click)="reset()"
    *ngIf="error || claimService.hash"
    i18n
  >
    Check another file
  </button>
  <footer fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="8px">
    <trustsuite-language [loadConfig]="false"></trustsuite-language>
    <a href="//www.trustcerts.de">Copyright by TrustCerts</a>
    <a href="//www.trustcerts.de/impressum" i18n>Imprint</a>
  </footer>
</div>
